module.exports = __webpack_public_path__ + "static/media/icon-parents.dad7dadd.svg";